import { Select } from '@/shared/components';

interface Props {
  value: number;
  onChange: (next: number) => void;
}

const SIZES = [25, 50, 100, 200] as const;

/**
 * Sprint-8 B.1.2: Page-Size-Dropdown im Footer der BookingsList.
 * Bewusst KEIN "Alle" — ohne Virtualisierung wuerde der Browser bei >500 Rows zaeh.
 */
export function PageSizeSelector({ value, onChange }: Props) {
  return (
    <label className="text-ink-faint flex items-center gap-2 text-xs">
      <span>Pro Seite</span>
      <Select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-auto py-1.5 pl-3 pr-8 text-xs"
        aria-label="Anzahl Buchungen pro Seite"
      >
        {SIZES.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </Select>
    </label>
  );
}
